/**
 * Pure project sorting used by both dashboard views (grid dropdown + list
 * headers share one sort model). Kept side-effect free so it can be unit
 * tested without the store or DOM.
 *
 * @param {Array} projects - project objects ({ title, lastChangedDate, ... })
 * @param {'date'|'name'} key - sort field
 * @param {'asc'|'desc'} dir - direction
 * @returns {Array} a new sorted array (input is not mutated)
 */
export function sortProjects(projects, key, dir) {
    const list = Array.isArray(projects) ? projects.slice() : [];
    const factor = dir === 'asc' ? 1 : -1;

    list.sort((a, b) => {
        let cmp;
        if (key === 'name') {
            const an = (a && a.title ? String(a.title) : '').toLowerCase();
            const bn = (b && b.title ? String(b.title) : '').toLowerCase();
            cmp = an.localeCompare(bn);
        } else {
            // default: date (lastChangedDate). Missing dates sort oldest.
            const at = a && a.lastChangedDate ? new Date(a.lastChangedDate).getTime() : 0;
            const bt = b && b.lastChangedDate ? new Date(b.lastChangedDate).getTime() : 0;
            cmp = at - bt;
        }
        return cmp * factor;
    });

    return list;
}

/**
 * True when the Dashboard must load every batch before this sort is right
 * (Josh, 21 Oct 2026). Batches load newest first by date, so only
 * "Last Updated, newest first" is correct on a partial load; by name, or
 * oldest first, a show in an unloaded batch would be missing from its place.
 *
 * @param {{key: string, dir: string}} sort - the current sort
 * @param {boolean} allLoaded - every batch is already in
 * @returns {boolean}
 */
export function needsAllProjectsForSort(sort, allLoaded) {
    if (allLoaded || !sort) return false;
    return sort.key === 'name' || sort.dir === 'asc';
}

export default sortProjects;


// WEBPACK FOOTER //
// ./src/lib/projectSort.js